import { useSelector } from 'react-redux';

export default function useSelectedTemplateId() {
  return useSelector(state => state.layout.selectedTemplateId);
}